import React from "react";
import "./styles/App.css";
import SplashScreen from "./components/SplashScreen"

function TVApp(props) {
    return (
		<SplashScreen venue={props.venue} />
    );
}

export default TVApp;
